const routes = [
    //铁矿石
    {
        path: 'ironstone',
        name: '铁矿石',
        component: () => import('@/views/ironstone/index'),
    },
    {
        path: 'ironstone/twoPage/industry',
        name: '铁矿石行业动态二级页',
        component: () => import('@/views/ironstone/twoPage/industry')
    },
    {
        path: 'ironstone/industry',
        name: '铁矿石行业动态详情页',
        component: () => import('@/views/ironstone/detail/industry')
    },
    {
        path: 'ironstone/twoPage/price',
        name: '铁矿石价格二级页',
        component: () => import('@/views/ironstone/twoPage/price')
    },
    {
        path: 'ironstone/price',
        name: '铁矿石价格详情页',
        component: () => import('@/views/ironstone/detail/priceIndex')
    },
    {
        path: 'ironstone/twoPage/stock',
        name: '铁矿石库存二级页',
        component: () => import('@/views/ironstone/twoPage/stock')
    },
    {
        path: 'ironstone/stock',
        name: '铁矿石库存详情页',
        component: () => import('@/views/ironstone/detail/stock')
    },
    {
        path: 'ironstone/twoPage/exit',
        name: '铁矿石进出口量二级页',
        component: () => import('@/views/ironstone/twoPage/exit')
    },
    {
        path: 'ironstone/exit',
        name: '铁矿石进出口量详情页',
        component: () => import('@/views/ironstone/detail/exit')
    },
    {
        path: 'ironstone/twoPage/report',
        name: '铁矿石研究报告二级页',
        component: () => import('@/views/ironstone/twoPage/report')
    },
    {
        path: 'ironstone/twoPage/standard',
        name: '铁矿石技术及标准二级页',
        component: () => import('@/views/ironstone/twoPage/standard')
    },
    {
        path: 'ironstone/twoPage/despatch',
        name: '铁矿石发运和到港二级页',
        component: () => import('@/views/ironstone/twoPage/despatch')
    },
    {
        path: 'ironstone/despatch',
        name: '铁矿石发运和到港详情页',
        component: () => import('@/views/ironstone/detail/despatch')
    },
    {
        path: 'ironstone/forecast',
        name: '铁矿石价格预测详情页',
        component: () => import('@/views/ironstone/detail/forecast')
    },
    {
        path: 'ironstone/twoPage/forecast',
        name: '铁矿石价格预测二级页',
        component: () => import('@/views/ironstone/twoPage/forecast')
    },
]
export default routes
